import CartCounter from './CartCounter.jsx';

export default CartCounter;


// WEBPACK FOOTER //
// ./src/components/CartCounter/index.jsx